module.exports = __webpack_public_path__ + "img/flythehike-icon.6d20063f.png";